import { render, staticRenderFns } from "./AltHeader.vue?vue&type=template&id=5b016584&scoped=true&"
import script from "./AltHeader.vue?vue&type=script&lang=js&"
export * from "./AltHeader.vue?vue&type=script&lang=js&"
import style0 from "./AltHeader.vue?vue&type=style&index=0&id=5b016584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b016584",
  null
  
)

export default component.exports